<div class="order-card" (click)="onClick()" tabindex="0">
  <div class="order-card__header">
    <div class="title">
      <div class="title-block">
        <span class="table-name">{{ tableName || 'Sin mesa' }}</span>
      </div>
      <span class="divider">•</span>
      <span class="header-meta mono">{{ date | date: 'dd/MM/yy HH:mm':'America/Santiago' }}</span>
      <span class="divider">•</span>
      <span class="order-id">Orden #{{ orderId }}</span>
    </div>
    <div class="header-right">
      <span class="status-chip" [ngClass]="statusClass">{{ status }}</span>
      <ng-container *ngIf="isAdmin">
        <button class="admin-btn edit-btn" type="button" (click)="onEdit($event)" matTooltip="Editar orden">
          <mat-icon>edit</mat-icon>
        </button>
        <button class="admin-btn delete-btn" type="button" (click)="onDelete($event)" matTooltip="Eliminar orden">
          <mat-icon>delete</mat-icon>
        </button>
      </ng-container>
    </div>
  </div>
  <div class="order-card__body compact">
    <ng-container *ngIf="(items?.length || 0) > 0; else productSummaryRow">
      <div class="order-card__products">
        <div class="products-left">
          <span class="label">Productos</span>
        </div>
      </div>
      <div class="items-table">
        <div class="item-row" *ngFor="let it of items" [class.canceled]="(it.status || '').toLowerCase() === 'canceled'">
          <div class="item-name" [matTooltip]="it.name" matTooltipPosition="above">
            <div class="ellipsis">{{ it.name }}</div>
            <div class="option-list" *ngIf="(it.options?.length || 0) > 0">
              <div class="option-list__item" *ngFor="let opt of it.options">{{ opt.qty }} × {{ opt.name }}</div>
            </div>
          </div>
          <span class="item-qty mono">{{ it.qty }}</span>
          <span class="item-status chip" [ngClass]="'chip-' + (it.status || 'pending')">{{ itemStatusLabel(it.status) }}</span>
          <span class="item-line mono">{{ (it.lineTotal ?? ((it.price || 0) * (it.qty || 0))) | currency: 'CLP' }}</span>
        </div>
      </div>
    </ng-container>
    <ng-template #productSummaryRow>
      <div class="order-card__products" *ngIf="productSummary">
        <div class="products-left">
          <span class="label">Productos</span>
          <span class="value ellipsis" [matTooltip]="productSummary" matTooltipPosition="above">{{ productSummary }}</span>
        </div>
      </div>
    </ng-template>

    <div class="order-card__totals-table" *ngIf="priceSummary">
      <div class="totals-row">
        <span class="mini-label">Total</span>
        <span class="mono">{{ priceSummary.total | currency: 'CLP' }}</span>
      </div>
      <div class="totals-row">
        <span class="mini-label">Desc.</span>
        <span class="mono">{{ priceSummary.discount | currency: 'CLP' }}</span>
      </div>
      <div class="totals-row" *ngIf="isDelivery">
        <span class="mini-label">Delivery</span>
        <span class="mono">{{ (priceSummary.delivery || 0) | currency: 'CLP' }}</span>
      </div>
      <div class="totals-row">
        <span class="mini-label">Prop.</span>
        <span class="mono">{{ priceSummary.tip | currency: 'CLP' }}</span>
      </div>
      <div class="totals-row payable-row">
        <span class="mini-label">A pagar</span>
        <span class="mono">{{ priceSummary.payable | currency: 'CLP' }}</span>
      </div>
    </div>

    <div class="order-card__footer" *ngIf="hasPayment">
      <ng-container *ngIf="paid > 0; else onlyPending">
        <span class="mono">Pagado {{ paid | currency: 'CLP' }}</span>
        <span class="mono" *ngIf="pending !== 0">Pendiente {{ pending | currency: 'CLP' }}</span>
      </ng-container>
      <ng-template #onlyPending>
        <span class="mono">Pendiente {{ payable | currency: 'CLP' }}</span>
      </ng-template>
      <span class="chip chip-method" *ngIf="paymentMethodsLabel">{{ paymentMethodsLabel }}</span>
    </div>

    <!-- Cliente como fila separada al final -->
    <div class="order-card__row customer-row" *ngIf="customerName">
      <span class="label">Cliente</span>
      <span class="value ellipsis" [matTooltip]="customerName" matTooltipPosition="above">{{ customerName }}</span>
    </div>
  </div>
</div>
